import MapElementProps from "../MapElementProps";

import './MapStyleControl.scss';
import {useAppSelector} from "../../../redux/hooks";
import {selectLocationError} from "../../../redux/features/location/slice";
import MapIControl from "./MapIControl";
import { t } from "../../../i18n";

const LocationErrorControl = ({map}: MapElementProps) => {
    const locationError: string | undefined = useAppSelector(selectLocationError);

    return (
        <MapIControl map={map!} position='top-left' doShow={() => !!locationError}>
            <div className="error-control">
                {t('web.map.locationError', { error: locationError ?? '' })}
            </div>
        </MapIControl>
    );
}

export default LocationErrorControl;